export var SettingScope;
(function (SettingScope) {
    SettingScope["Installation"] = "installation";
    SettingScope["App"] = "app";
})(SettingScope || (SettingScope = {}));
